import Container from '../Container';
import Heading from '../Heading';
import Card from './Card';
import styles from './styles.module.css'

const Service = ({services}) => {
    
    return (
        <section className={`${styles['section-4']} py-5`}>
            <Container className="py-0 py-lg-5">
                <div className='row'>
                    <div className='col-12'>
                        <Heading 
                            heading={'Services we can help you with'}
                        />
                    </div>
                </div>
                {services && services.length > 0 &&
                    <div className='row mt-5'>
                        {services.map(item => 
                            <Card 
                                key={item.id} 
                                title={item.title}
                                description={item.description}
                                imageUrl={item.image_url}
                                link={item.link}
                            />
                        )}
                    </div>
                }                
            </Container>
        </section>
    );
};

export default Service;